import {HttpRequest, HttpResponse} from '@angular/common/http';

/**
 * Represents a cache for http requests.
 */
export abstract class RequestCache {
    /**
     * Stores the default maximum cache age in ms.
     */
    public static readonly DEFAULT_MAX_AGE = 1000 * 60 * 60 * 2;

    /**
     * Gets a cache entry of a http request.
     *
     * @param req The http request.
     * @param maxAge The maximum age of the cache entry.
     * @return The cached http response or undefined if it could not be found.
     */
    abstract get(req: HttpRequest<any>, maxAge: number): HttpResponse<any> | undefined;

    /**
     * Caches a http response of a http request.
     *
     * @param req The http request.
     * @param response The http response.
     */
    abstract put(req: HttpRequest<any>, response: HttpResponse<any>): void;
}
